import JourneyStepProvider, { JourneyStepContext } from '../../contexts/JourneyStepContext'
import * as consts from '../../constants'
import Journey from '../../journeys/LoanEverybyte'

function LoanEverybyte() {
  return (
    <JourneyStepProvider maxSteps={consts.LOANS_NEW_PHASE_MAX}>
      <JourneyStepContext.Consumer>
        {({ step, reset }) => (
          <div className='page grey-shadow'>
            <div className='page-head'>
              <h2>
                <span>Loans &gt; Request Loan &gt;</span> {consts[`LOANS_NEW_PHASE_${step}`]}
              </h2>
            </div>

            <Journey
              onSuccess={() => {
                reset()
              }}
            />
          </div>
        )}
      </JourneyStepContext.Consumer>
    </JourneyStepProvider>
  )
}

export default LoanEverybyte
